export const onClientEntry = () => {
  const DESIGN_W = 1920;

  function updateScale() {
    const w = document.documentElement.clientWidth;
    document.documentElement.style.setProperty('--scale', String(w / DESIGN_W));
  }

  // Initial calculation
  updateScale();

  // Listen to resize events to maintain scale dynamically
  window.addEventListener('resize', updateScale);
};
